"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearGA4EventData = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function clearGA4EventData() {
    (0, pushToDataLayer_1.pushToDataLayer)({ eventData: null });
}
exports.clearGA4EventData = clearGA4EventData;
//# sourceMappingURL=clearGA4EventData.js.map